import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLenis } from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
  useLenis();
  const location = useLocation();
  const hideFooter = location.pathname.startsWith("/reviews");

  return (
    <div className="grain min-h-screen bg-beige-100 text-navy-600 relative">
      <Nav />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      {!hideFooter && <Footer />}
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "hsl(215 50% 15%)",
            color: "hsl(40 25% 95%)",
            border: "1px solid hsl(215 50% 15%)",
            borderRadius: 0,
            fontFamily: "Montserrat, sans-serif",
            letterSpacing: "0.04em",
            fontSize: "12px",
          },
        }}
      />
    </div>
  );
}
